// 通用公共变量与方法
import _ from 'lodash'
import Cookie from 'js-cookie'
import api from '../../../api/common'
import * as types from '../../types/type'
import config from '../../../config'

export default {
  state: {
    ajaxBaseUrl: config.ajaxBaseUrl,
    imageSrcPrefix: config.imageSrcPrefix,
    isFullScreenLoading: false,
    companyInfo: {},
    userInfo: {},
    aboutUsData: {},
    isEnableCreditQuotaSwitchs: false,   // 是否启用额度开关
    activeName: '2',
    pageCurrent: 1,
    msgNum: 0,
    activeNum: 1
  },
  getters: {
    [types.GET_AJAX_BASE_URL]: state => state.ajaxBaseUrl,
    [types.GET_IMAGE_SRC_PREFIX]: state => state.imageSrcPrefix,
    [types.GET_COMPANY_INFO]: state => state.companyInfo,
    [types.GET_ABOUT_US_DATA]: state => state.aboutUsData,
    [types.GET_FULL_SCREEN_LOADING_STATE]: state => state.isFullScreenLoading,
    [types.GET_USER]: state => state.userInfo,
    [types.IS_LOGIN]: state => !_.isEmpty(state.userInfo),
    [types.IS_USEING_LIMIT]: state => state.isEnableCreditQuotaSwitchs,
    [types.ACTIVE_NAME]: state => state.activeName

  },
  actions: {
    [types.GET_INDEX_INFO]: ({dispatch, commit}) => api.getIndexInfo().then((res) => {
      const resData = res.data
      const result = res.data.data
      //document.title = result.productNameCN
      if (Number(resData.code) === 0) {
        commit(types.SET_INDEX_CAROUSEL, result.bannerFileIds)
        commit(types.SET_COMPANY_INFO, result)
        commit(types.SET_HOT_PRODUCTS, result.hotProductList.slice(0, 4))
      } else {
        dispatch(types.SET_FAIL_MESSAGE, {
          show: true,
          content: resData.result || '首页信息获取错误'
        })
      }
    }),
    [types.GET_ABOUT_US] ({dispatch, commit}) {
      return api.getAboutUsInfo().then((res) => {
        if (Number(res.data.code) === 0) {
          commit(types.SET_ABOUT_US, res)
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: res.data.result || '关于我们信息获取错误'
          })
        }
      })
    },
    [types.GET_ENABLE_CREDIT_QUOTA_SWITCH]: ({dispatch, commit}) => api.getEnableCreditQuotaSwitch().then((res) => {
      commit(types.SET_ENABLE_CREDIT_QUOTA_SWITCH, res.data.result)
    }),
    [types.GET_GENERATE_RSA_PUBLIC_KEY]: ({commit}) => api.generateRSAPublicKey(),
    [types.GET_PAGE_CURRENT] ({commit}, params) {
      commit(types.SET_PAGE_CURRENT, params.pageCurrent);
    }
  },
  mutations: {
    [types.EMPTY_MUTATION] (state, params) {},
    [types.SET_ENABLE_CREDIT_QUOTA_SWITCH] (state, data) {
      state.isEnableCreditQuotaSwitchs = data
    },
    [types.SET_COMPANY_INFO] (state, data) {
      const friendlyLink = []
      data.partnerFileIds.forEach((item, i) => {
        friendlyLink.push({
          id: item,
          imgSrc: `${state.imageSrcPrefix}${item}`,
          url: data.partnerUrls[i]
        })
      })

      state.companyInfo = {
        fullChnName: data.productFullNameCN,
        fullEngName: data.productFullName,
        shortChnName: data.productNameCN,
        shortEngName: data.productName,
        name: data.pageFoot,
        tel: data.serviceNumber,
        logo: data.logo !== undefined ? `${state.imageSrcPrefix}${data.logo}` : '',
        aboutCompany: data.aboutCompany.replace(/style="[^"]*?"|(\s)*/g, '').replace(/<br \/>/g, '<p/>'),
        friendlyLink
      };
    },
    [types.SET_USER] (state, data) {
      state.userInfo = data

      Cookie.set('userData', encodeURIComponent(JSON.stringify(data)));
    },
    [types.SET_FULL_SCREEN_LOADING_STATE] (state, data) {
      state.isFullScreenLoading = data.isFullScreenLoading
    },
    [types.SET_ABOUT_US] (state, data) {
      state.aboutUsData = data.data.data
    },
    [types.SET_ACTIVE_NAME] (state, data) {
      state.activeName = data;
    },
    [types.SET_PAGE_CURRENT] (state, data) {
      state.pageCurrent = data;
    },
    changeState (state, value) {
      state.msgNum = value;
    },
    changeActive (state, value) {
      state.activeNum = value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/common/common.js